
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-data-grid/tutorials/server-side-data",
      function () {
        return require("private-next-pages/x/react-data-grid/tutorials/server-side-data/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-data-grid/tutorials/server-side-data"])
      });
    }
  